module.exports = __webpack_public_path__ + "static/DontOpenYourEyes1-ef713acb5d58e27e44e98f2d0e4c821f.png";